export default "__VITE_ASSET__c3911575__"